import { z } from 'zod';

export const ProfileSchema = z.object({
  id: z.string().trim().optional(),
  name: z.string().trim().min(1, 'Name is required'),
  title: z.string().trim().optional(),
  homepage: z
    .string()
    .trim()
    .optional()
    .refine(
      value => !value || /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[^\s]*)?$/.test(value),
      'Please enter a valid URL'
    ),
  companyName: z.string().trim().optional(),
  industry: z.string().trim().optional(),
  location: z.string().trim().min(1, 'Location is required'),
  companyIntroduction: z.string().trim().optional(),
});

export type ProfileDetail = z.infer<typeof ProfileSchema>;
